import React, {useEffect} from "react";
import { isMobile } from "helpers/Mobile";
import BusinessTableItem from "./BusinessTableItem";
import Icon from "components/MainApp/atoms/Icon/icon";

import styles from "./BusinessTable.module.scss";
import i18n from "i18n";

const BusinessTable = ({ businesses, headers, filtersApplied, handleClick, headerClickHandler }) => {

  const renderHeaderItem = header => {
    return (
      <div
        data-automation-id={`sort-by-${header.name}`}
        onClick={() => {
          headerClickHandler(header.name);
        }}
        data-filter-name={header.name}
        className={`${styles["business-table-header-item"]} ${
          styles[`business-table-header-${header.name}`]
        }`}
        key={header.name}
      >
        {header.title}
        {header.name !== "image" && (
          <span
            className={`${styles["business-table-header-icon-span"]} ${
              header.active ? styles["active"] : ""
            }  ${header.direction ? "" : styles["down"]}`}
          >
            {" "}
            <i className="icon-iconos_flecha-ordenar"></i>
          </span>
        )}
      </div>
    );
  };
  const table = (
    <React.Fragment>
      <div className={styles["business-table-desktop"]} data-automation-id="apps-table">
        {!isMobile && (
          <div className={styles["business-table-header"]}>
            {Array.isArray(headers) && headers.map((header) => renderHeaderItem(header))}
            {!Array.isArray(headers) && Object.keys(headers).map((key) => renderHeaderItem(headers[key]))}
            <div className="business-table-header-item business-table-header-button"></div>
          </div>
        )}
        <div className={styles["business-table-content"]}>
          {businesses?.map((app) => {
            return (
              <div className={styles["business-table-content-item"]} key={app.id}>
                <BusinessTableItem business={app} handleClick={handleClick} />
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );

  const noitems = (
    <div className={styles["business-table-no-items"]}>
      <Icon name="apps" fill="#3C7AF5" width={87} height={65}></Icon>
      <h1>{i18n.t("no.results")}</h1>
    </div>
  );

  return (
    <div className={styles["business-table-container"]}>
      {businesses?.length > 0 ? table : !filtersApplied ? noitems : ""}
    </div>
  );
};

export default BusinessTable;
